// extracted by mini-css-extract-plugin
export default {"li":"List_li__MjkmY","categoryBanner":"List_categoryBanner__xTwxR"};